import { render } from "./CoreMessage.vue?vue&type=template&id=24a54be2"
import script from "./CoreMessage.vue?vue&type=script&lang=js"
export * from "./CoreMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__